import { combineReducers } from 'redux';
import sellerRegistrationReducer from './sellerRegistrationReducer';
import buyerRegistrationReducer from './buyerRegistrationReducer';
import affiliatorRegistrationReducer from './affiliatorRegistrationReducer';
import forgetPasswordReducer from './forgetPasswordReducer';
import sellerLoginReducer from './loginReducer';
import buyerLoginReducer from './loginReducer';
import errorsReducer from './errorsReducer';
import productUploadReducer from './productUploadReducer';
import recommandedProductReducer from './recommandedProductReducer';

export default combineReducers({
    sellerRegistration: sellerRegistrationReducer,
    buyerRegistration: buyerRegistrationReducer,
    affiliatorRegistration: affiliatorRegistrationReducer,
    forgetPassword: forgetPasswordReducer,
    sellerLoginReducer: sellerLoginReducer,
    buyerLoginReducer: buyerLoginReducer,
    errors: errorsReducer,
    productUpload:productUploadReducer,
    products:recommandedProductReducer,
});